import app from "flarum/common/app";
export const gradients = ["violet", "sunset", "ocean", "forest", "rose"];
export function record(v) {
  return typeof v === "object" && v !== null;
}
const integer = v => typeof v === "number" && Number.isSafeInteger(v) && v >= 0;
function author(v) {
  return record(v) && (v.id === null || integer(v.id)) && typeof v.name === "string" && (v.avatar === null || typeof v.avatar === "string");
}
export function fact(v) {
  if (!record(v) || !integer(v.id) || !integer(v.revision) || typeof v.content !== "string" || !gradients.some(g => g === v.background) || !["pending", "approved", "rejected"].includes(String(v.status)) || !Array.isArray(v.images) || v.images.length > 5 || !v.images.every(i => record(i) && typeof i.path === "string" && typeof i.url === "string") || !author(v.author) || typeof v.createdAt !== "string" || typeof v.expiresAt !== "string" || !Number.isFinite(Date.parse(v.expiresAt)) || !record(v.counts) || ![v.counts.likes, v.counts.views, v.counts.comments].every(integer) || ![v.liked, v.canEdit, v.canDelete, v.canModerate].every(x => typeof x === "boolean")) throw new Error("Invalid story response");
  return v;
}
export function comment(v) {
  if (!record(v) || !integer(v.id) || typeof v.content !== "string" || !author(v.author) || typeof v.createdAt !== "string" || typeof v.canDelete !== "boolean") throw new Error("Invalid comment response");
  return v;
}
export function listing(v, parse) {
  if (!record(v) || !Array.isArray(v.data) || !(v.next === null || integer(v.next))) throw new Error("Invalid list response");
  return {
    data: v.data.map(parse),
    next: v.next
  };
}
export function single(v) {
  return fact(record(v) ? v.data : null);
}
export function permitted(key) {
  return record(app.data.xgayFact) && app.data.xgayFact[key] === true;
}
export function t(key) {
  return app.translator.trans("xgay-fact.lib." + key);
}
export function request(path, method, body) {
  if (method === void 0) {
    method = "GET";
  }
  return app.request({
    method,
    url: app.forum.attribute("apiUrl") + "/facts" + path,
    body
  });
}
export function expired(story) {
  return Date.parse(story.expiresAt) <= Date.now();
}
export function shareUrl(story) {
  return app.forum.attribute("baseUrl") + "/fact/" + story.id;
}
flarum.reg.add('xgay-fact', 'common/api', { gradients: gradients,record: record,fact: fact,comment: comment,listing: listing,single: single,permitted: permitted,t: t,request: request,expired: expired,shareUrl: shareUrl, });